import React from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  LegacyBox,
  LegacyText,
  Actions,
  Action,
  DownloadIcon,
} from '@gogame/components';
import { useScreenState } from '@gogame/screens';

import NodesBudgetGrid from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/NodesBudgetGrid';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { useExportNodesMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/hooks';

import { Header, Title, EmptyMessageBox } from './components';

const NodesBudget = ({
  levelName,
  lastLevel,
  withDownloadNode,
  withLinkName,
  withCBudgetEmptyPlaceholder,
}) => {
  const { version } = useScreenState();
  const { id, nodes } = useViewStateByResolveName();
  const exportNodes = useExportNodesMarketingPlan();

  const handleExportNodes = React.useCallback(() => {
    exportNodes({ parentId: id, version });
  }, [id]);

  return (
    <React.Fragment>
      <Header gutter={8} align={'center'}>
        <LegacyBox grow={1}>
          <Title>{levelName}</Title>
        </LegacyBox>
        {withDownloadNode ? (
          <Actions>
            <Action
              icon={<DownloadIcon />}
              label={'Export'}
              onClick={handleExportNodes}
            />
          </Actions>
        ) : null}
      </Header>
      {isEmpty(nodes) ? (
        <EmptyMessageBox justifyContent={'center'}>
          <LegacyText>{`No ${levelName} selected`}</LegacyText>
        </EmptyMessageBox>
      ) : (
        <NodesBudgetGrid
          lastLevel={lastLevel}
          withLinkName={withLinkName}
          withCBudgetEmptyPlaceholder={withCBudgetEmptyPlaceholder}
        />
      )}
    </React.Fragment>
  );
};

export default NodesBudget;
